
require("pixi-particles");

import {AnimatedParticle, Emitter, EmitterConfig, OldEmitterConfig} from "pixi-particles";
import { gsap } from "gsap";
import { SanQuentin2 } from "../../SanQuentin2";
import { Helper } from "../../../core/utils/Helper";
import { TimeCheckPoints } from "../../../core/utils/TimeCheckPoints";

export class ParticleController {

    private loopTl:gsap.core.Timeline | null;
    
    private _emitter:Emitter;
    private _timeName:string = "";

    private deltaTime:number = 0;
    
    private get elapsedTime():number{
        return TimeCheckPoints.getCheckPointTime(this._timeName);
    }

    private set timeName(name:string){
        this._timeName = name;
        TimeCheckPoints.setCheckPoint(name);
    }
    
    constructor(type:string, layer:PIXI.Container, conf:EmitterConfig | OldEmitterConfig, loop?:boolean,frameRate?:number){
        this.timeName = type;
        const texture = SanQuentin2.assetLoader.getTextures(type);

        this._emitter = new Emitter(layer, [{
            framerate : frameRate ? frameRate : texture.length,
            loop : loop,
            hasLoaded : true,
            textures : texture
        }], conf);
        this._emitter.particleConstructor = AnimatedParticle;
        this._emitter.emit = false;
    }

    private update():void {
        this._emitter.update((this.elapsedTime - this.deltaTime) / 1000);
        this.deltaTime = this.elapsedTime;
    }

    public enableEmit(value:boolean):void {
        if(value){
            this.loopTl = Helper.setTimeline(this.loopTl!,{
                repeat:-1,
                onUpdate:() => this.update(),
                onRepeat:() => { if( this._emitter.particleCount == 0) this.loopTl = Helper.setTimeline(this.loopTl!) }
            });
            this.loopTl.to(this,{duration:1},0);
            this.loopTl.play();
            this.deltaTime = this.elapsedTime;
        } 
        this._emitter.emit = value;
    }

    public setPos(newPos:PIXI.Point):void{
        this._emitter.spawnPos.copyFrom(newPos);
    }
}